import React, { createContext, useContext } from 'react'
import { useCookie } from 'react-use'

const UsableNetAssistive = createContext()

export const useUsableNetAssistive = () => useContext(UsableNetAssistive)

export const UsableNetAssistiveContext = ({ children }) => {
  const UsableNetAssistiveCookie = useCookie('UsableNetAssistive')

  return (
    <UsableNetAssistive.Provider
      value={{
        isActive: UsableNetAssistiveCookie?.[0] === '1' ? true : false,
      }}
    >
      {children}
    </UsableNetAssistive.Provider>
  )
}
